// MobileDayGrid.tsx — Tagesraster-Wrapper für die Mobile-Tagesansicht
// (`/termine`, SP6). Dünner Wrapper um TimeGridView (SP1, RBC-Engine), der den
// Context auf View `day` hält. TimeGridView konsumiert view/currentDate aus dem
// CalendarStateContext; der Tag wird über den DaySelector/Shell gesteuert.
// onSelectSlot (SP3-Tap-Slot-Pfad) und onSelectEvent (SP2) reicht die Shell
// durch. KEIN onEventDrop/onEventResize (Touch-Drag bewusst aus, Plan §11).
// Zeitskala (T-31): mobil bewusst fest 15 min / 88px — TimeGridView ignoriert
// die gespeicherte Skala auf dem Phone (kompaktes Raster wäre kaum treffbar).

import React, { useEffect } from "react";
import TimeGridView from "./TimeGridView";
import { useCalendarState } from "./CalendarStateContext";
import type { CalendarGridEvent } from "./types";

export interface MobileDayGridProps {
    events: CalendarGridEvent[];
    onSelectEvent?: (e: CalendarGridEvent) => void;
    onSelectSlot?: (slot: { start: Date; end: Date; allDay: boolean }) => void;
}

export const MobileDayGrid: React.FC<MobileDayGridProps> = ({
    events,
    onSelectEvent,
    onSelectSlot,
}) => {
    const { view, setView } = useCalendarState();

    // Sicherstellen, dass der Context auf 'day' steht, falls die Shell ihn nicht
    // garantiert (z. B. Direkt-Mount des Raster-Sub-Modus).
    useEffect(() => {
        if (view !== "day") setView("day");
    }, [view, setView]);

    return (
        <TimeGridView
            events={events}
            onSelectEvent={onSelectEvent}
            onSelectSlot={onSelectSlot}
            // Touch-Drag bewusst deaktiviert (Plan §11): kein onEventDrop/
            // onEventResize → kein Long-Press↔Scroll-Konflikt. Neuanlage über
            // FAB + Tap-auf-Slot.
        />
    );
};

export default MobileDayGrid;
